// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import React, { FC } from "react";
// import { connect } from "react-redux"; // Valtech Custom Code

/* Valtech Custom Code */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Drawer, { DrawerPresentationProps } from "@insite/mobius/Drawer";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { ProductListSortSelectStyles } from "@store/Overrides/Widgets/ProductList/ProductListSortSelect";
import { boxStickyStyles } from "@store/Themes/common/mixins/box";
import { baseGridHiddenProps } from "@store/Themes/common/props/baseGrid";
import { filtersProps } from "@store/Themes/common/props/filters";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import setIsFilterNavOpen from "@toolkit/Framework/Store/Toolkit/Pages/ProductList/Handlers/setIsFilterNavOpen";
import { useIsFilterNavOpen } from "@toolkit/Framework/Store/Toolkit/Pages/ProductList/ProductListHooks";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import getColor from "@insite/mobius/utilities/getColor";

const SortSelect = getWidgetComponent("ProductList/ProductListSortSelect");

const mapDispatchToProps = {
    setIsFilterNavOpen,
};
/* Valtech Custom Code */

const mapStateToProps = (state: ApplicationState) => ({
    view: state.pages.productList.view,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>; // Valtech Custom Code

export interface ProductListColumnsStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    leftColumnTableViewGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnTableViewGridItem?: GridItemProps;
    // Valtech Custom Code
    sortSelect?: ProductListSortSelectStyles;
    drawer?: DrawerPresentationProps;
    drawerContentWrapper?: InjectableCss;
    drawerApplyWrapper?: InjectableCss;
    drawerApplyButton?: ButtonPresentationProps;
}

export const columnsStyles: ProductListColumnsStyles = {
    container: {
        ...baseGridHiddenProps.container,
        css: css`
            ${baseGridHiddenProps.container?.css}
            ${breakpointValues(pxToRemArray([20, null, 25, null, 30]), "margin-top")}

            &:first-child {
                margin-top: 0;
            }
        `,
    },
    leftColumnGridItem: {
        ...baseGridHiddenProps.sideColumn,
        css: css`
            display: block;
            background-color: ${getColor("common.shadesLight")};
            border-top-left-radius: ${pxToRem(16)};
            border-top-right-radius: ${pxToRem(16)};
        `,
    },
    rightColumnGridItem: baseGridHiddenProps.mainColumn,
    sortSelect: {
        select: {
            labelProps: {
                ...filtersProps.title,
                forwardAs: "label",
            },
            cssOverrides: {
                formField: css`
                    ${x => x.theme.formField.defaultProps?.cssOverrides?.formField}
                    ${filtersProps.flatSection?.css}
                `,
                formInputWrapper: css`
                    ${x => x.theme.formField.defaultProps?.cssOverrides?.formInputWrapper}
                    margin-top: 0 !important; /* Remove default spacing between field and label */
                `,
            },
        },
    },
    drawer: {
        cssOverrides: {
            drawerContent: css`
                ${x => x.theme.drawer.defaultProps?.cssOverrides?.drawerContent}
                display: flex;
                height: 100%;
                flex-direction: column;
                justify-content: space-between;
            `,
        },
    },
    drawerContentWrapper: {
        css: css`
            padding: ${pxToRem(20)};
        `,
    },
    drawerApplyWrapper: {
        css: css`
            ${boxStickyStyles()}
            position: sticky;
            bottom: 0;
        `,
    },
    drawerApplyButton: {
        variant: "primary",
        css: css`
            ${x => x.theme.button.primary.css}
            width: 100%;
        `,
    },
};

const styles = columnsStyles;

const ProductListColumns: FC<Props> = ({ id, view, setIsFilterNavOpen /* Valtech Custom Code */ }) => {
    /* Valtech Removed - leftColumnGridItemStyle & rightColumnGridItemStyle */
    /* Valtech Custom Code */
    const isFilterNavOpen = useIsFilterNavOpen();
    const closeDrawer = () => setIsFilterNavOpen({ isOpen: false });
    /* Valtech Custom Code */
    return (
        <>
            <GridContainer {...styles.container} data-test-selector="productList_columns" /* Bunzl Custom Code */>
                <GridItem
                    {
                        ...styles.leftColumnGridItem /* Valtech Custom Code */
                    }
                    data-test-selector="productList_columns_filtersColumn" /* Bunzl Custom Code */
                >
                    <Zone contentId={id} zoneName="Content00" />
                </GridItem>
                <GridItem
                    {
                        ...styles.rightColumnGridItem /* Valtech Custom Code */
                    }
                    data-test-selector="productList_columns_contentColumn" /* Bunzl Custom Code */
                >
                    <Zone contentId={id} zoneName="Content01" />
                </GridItem>
            </GridContainer>
            {/* Valtech Custom Code */}
            <Drawer
                draggable
                position="left"
                isOpen={isFilterNavOpen}
                handleClose={closeDrawer}
                contentLabel={translate("Sort & Filter")}
                {...styles.drawer}
                data-test-selector="productList_columns_filtersDrawer" /* Bunzl Custom Code */
            >
                <StyledWrapper
                    {...styles.drawerContentWrapper}
                    data-test-selector="productList_columns_drawerContentWrapper" /* Bunzl Custom Code */
                >
                    <SortSelect
                        fields={{}}
                        uid="productListSortSelectMobile"
                        labelPosition="top"
                        extendedStyles={styles.sortSelect}
                        data-test-selector="productList_columns_mobileSort" /* Bunzl Custom Code */
                    />
                    <Zone contentId={id} zoneName="Content00" />
                </StyledWrapper>
                <StyledWrapper
                    {...styles.drawerApplyWrapper}
                    data-test-selector="productList_columns_drawerApplyWrapper" /* Bunzl Custom Code */
                >
                    <Button
                        onClick={closeDrawer}
                        {...styles.drawerApplyButton}
                        data-test-selector="productList_columns_applyFiltersButton" /* Bunzl Custom Code */
                    >
                        {translate("Apply Filters")}
                    </Button>
                </StyledWrapper>
            </Drawer>
            {/* Valtech Custom Code */}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ProductListColumns), // Valtech Custom Code
    definition: {
        group: "Product List",
        displayName: "Columns",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
